<template>
  <div>
    <create
      v-if="craeteDialog"
      @createData="create($event)"
      @closePopup="closeCreate"
      :dialog="craeteDialog"
      :loader="loader"
    />
    <edit
      v-if="editDialog"
      @editData="edit($event)"
      @closePopup="closeEdit"
      :dialog="editDialog"
      :dialogData="dialogData"
      :loader="loader"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteManeger($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
      :loader="loader"
    />
    <country-filter
      @getData="setDataFilter($event)"
      @clearData="setDataFilter({})"
    />
    <v-row class="mb-4">
      <v-col class="d-flex justify-end"
        ><v-btn color="primary" @click="createAble"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :create="createAble"
      :editable="editAble"
      :deleteable="deleteAble"
      :data="tableData.data"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import { Country } from "@/store/common/country";
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
import countryFilter from "./filter.vue";

export default {
  components: {
    dataTable,
    deletePopup,
    create,
    edit,
    countryFilter,
  },
  data() {
    return {
      Country,
      dialogData: null,
      craeteDialog: false,
      editDialog: false,
      deleteDialog: false,
      deleteDialogData: null,
      filterData: {},
    };
  },
  methods: {
    getData(page) {
      Object.assign(this.filterData, { page: page });
      Country.get(this.filterData);
    },
    setDataFilter(data) {
      this.filterData = data;
      this.getData(1);
    },
    //create
    createAble() {
      this.craeteDialog = true;
      this.popupType = "create";
    },
    async create(data) {
      await Country.post(data);
      this.craeteDialog = false;
    },
    closeCreate() {
      this.craeteDialog = false;
    },

    //edit
    editAble(obj) {
      this.dialogData = obj;
      this.editDialog = true;
    },
    async edit(data) {
      await Country.edit(data.data, data.id);
      this.editDialog = false;
    },
    closeEdit() {
      this.editDialog = false;
    },

    //delete
    deleteAble(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    async deleteManeger(id) {
      await Country.deleteItem(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    tableData() {
      return Country.tableData;
    },
    showData() {
      return Country.tableData.showData;
    },
    loader() {
      return Country.getState.loading;
    },

    pagination() {
      return Country.tableData.meta;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
